export function formatDateTime(dateString, dateOnly = false) {
  if (!dateString) return "";

  const date = new Date(dateString);

  if (isNaN(date.getTime())) return "";

  // Format date
  const formattedDate = date.toLocaleDateString("fr-CA", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  if (dateOnly) {
    return formattedDate;
  }

  // Format time uniquement si dateOnly = false
  const formattedTime = date.toLocaleTimeString("fr-CA", {
    hour: "2-digit",
    minute: "2-digit",
  });

  return `${formattedDate} ${formattedTime.replace(":", "h")}`;
}
